module.exports = __webpack_public_path__ + "img/whiteBar.27526000.png";